import { useRouter } from 'next/router';
import { ContactSteps } from 'pages/[propertyId]/contact';

export const useContactParams = () => {
  const router = useRouter();

  const startDate = router.query?.startDate as string | undefined;
  const endDate = router.query?.endDate as string | undefined;
  const adults = router.query?.adults as string | undefined;
  const pChildren = router.query?.children as string | undefined;
  const infants = router.query?.infants as string | undefined;
  const pets = router.query?.pets as string | undefined;
  const propertyId = router.query?.propertyId as string | undefined;
  const step = (router.query?.step || ContactSteps.SendMessage.toString()) as string;

  return {
    startDate,
    endDate,
    adults,
    pChildren,
    infants,
    pets,
    propertyId,
    step,
  };
};
